// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/transactional/datafeed/v1/running_trade.proto (package securities.transactional.datafeed.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Change, TradeType } from "./entity_pb.js";

/**
 * @generated from message securities.transactional.datafeed.v1.RunningTrade
 */
export const RunningTrade = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.v1.RunningTrade",
  () => [
    { no: 1, name: "websocket_time", jsonName: "websocket_time", kind: "message", T: Timestamp },
    { no: 2, name: "stock", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "volume", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "action", kind: "enum", T: proto3.getEnumType(TradeType) },
    { no: 6, name: "is_global", jsonName: "is_global", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "time", kind: "message", T: Timestamp },
    { no: 8, name: "change", kind: "message", T: Change },
    { no: 9, name: "trade_number", jsonName: "trade_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message securities.transactional.datafeed.v1.RunningTradeBatch
 */
export const RunningTradeBatch = /*@__PURE__*/ proto3.makeMessageType(
  "securities.transactional.datafeed.v1.RunningTradeBatch",
  () => [
    { no: 1, name: "batch", kind: "message", T: RunningTrade, repeated: true },
  ],
);

